import React, { useEffect, useState } from "react";
import { PlanDetails, USER_TYPE_MAPPING } from "../../../constants/v2/common";
import { REVIEW_PLAN, USER_TYPE } from "../../../constants/onBoarding";
import { getPlanByUserType } from "../../../services/v2/PlanService";
import PremiumFeatureIcon from "../../../images/v2/premium-features-stars.svg";
import ArrowIcon from "../../../images/modal-right-arrow.svg";
import Button from "react-bootstrap/Button";
import { getActivePromoCodeDetails } from "../../../services/PlanService";

const PlanSelection = (props) => {
  const { userType, handleBackButtonClick,handlePageToggle ,userDetails } = props;
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [enablePromocode, setEnablePromocode] = useState(false);
  const [enablePromocodePeriod, setEnablePromoCodePeriod] = useState([]);
  const [fromSignUp, setFromSignUp] = useState(false);
  const [plan, setPlan] = useState(null);
  const selectedPlanDetails = PlanDetails.find(
    (plan) => plan.planName === selectedPlan
  );

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const mappedUserType = USER_TYPE_MAPPING[userType];
        if (!mappedUserType) throw new Error("Invalid user type");

        const payload = { userType: mappedUserType };
        const response = await getPlanByUserType(payload);
        if (response?.result[0]?.planName === "Basic Member") {
          setSelectedPlan("Member");
        } else {
          setSelectedPlan(response?.result[0]?.planName);
        }
        setPlan(response?.result[0]);
      } catch (err) {
        console.log(err);
        throw new Error("Error fetching plans:", err);
      }
    };

    if (userType) fetchPlans(); // Call the function only if userType is available
  }, [userType]);

  useEffect(() => {
    if (userDetails?.PlanName == null) {
      setFromSignUp(true);
    } else {
      setFromSignUp(false);
    }
    setSelectedPeriod(userDetails?.period);
    setSelectedPlan(userDetails?.PlanName);
  }, [userDetails]);

  useEffect(() => {
    getActivePromoCodeDetails().then((response) => {
      let temp = [];
      const res = _.get(response, "result", []);
      if (res?.length > 0) {
        const result = res.filter(
          (planDetails) =>
            planDetails?.UserType == 2 || planDetails?.UserType == 3
        );
        if (result && result.length > 0) {
          setEnablePromocode(true);
        }
        result.forEach((data) => {
          temp.push(data?.Period);
        });
        setEnablePromoCodePeriod(temp);
      }
    });
  }, []);

  return (
    <div className="gitcha-main-wrapper pb-0">
      <div className="content-wrapper vh-100">
        <div className="inner-layout-header-new bg-grey-variant">
          <div className="review-plan-header w-100">
            <div className="signup-login-header-top signup-header-txt clearfix">
              <a
                className="back-link"
                role="button"
                href={void 0}
                onClick={() => {
                  handleBackButtonClick({ prevPage: USER_TYPE });
                }}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z"
                    fill="#1B1C1E"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="inner-layout-content-new h-100">
          <div>
            <img src={PremiumFeatureIcon} alt="Premium-feature-icon" />
            <span>Try {plan?.planName} for free</span>
          </div>
          <h2>Access to exclusive tools to get the deal</h2>
          <div className="upgrade-card-btm">
            <ul className="upgrade-card-btm-list">
              {selectedPlanDetails &&
                selectedPlanDetails?.features.map((feature) => {
                  return <li className="upgrade-list-bg-blue">{feature}</li>;
                })}
            </ul>
          </div>

          <Button
            className="btn btn-primary flex-grow-1 l-space-0 ms-1"
            onClick={() =>
              handlePageToggle({
                activePage: REVIEW_PLAN,
                planDetails: {
                  period: selectedPeriod,
                  selectedPlan: selectedPlan,
                  fromSignUp: fromSignUp,
                  enablePromocode: enablePromocode,
                  enablePromocodePeriod: enablePromocodePeriod,
                },
              })
            }
          >
            Try free for 30 days
          </Button>

          <div>
            <div className="">
              <span>Skip for now</span>
              <img src={ArrowIcon} alt="Premium-feature-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanSelection;
